<template>
    <section ref="refHero" class="slice tag-page__hero">
        <div class="slice-content">
            <ShapeTopRight class="tag-page__hero__shape" />
            <div class="tag-page__hero__wrapper">
                <div>
                    <TagPageBreadcrumbs :tag="tag" />
                    <TagPageTitle :tag="tag" />
                    <TagPageDescription />
                    <div v-if="ctaUrl">
                        <VJoyButton :href="$withLocalePrefix(ctaUrl)" variant="main" rel="nofollow" data-component-source="tag-landing-page">
                            {{ ctaLabel }}
                        </VJoyButton>
                    </div>
                </div>
                <div v-if="prismicImage" class="tag-page__hero__image">
                    <PrismicImage :image="prismicImage" width="578" height="auto" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {useComponentTracking} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import PrismicImage from '~/components/PrismicImage.vue';
    import ShapeTopRight from '~/components/shape/ShapeTopRight.vue';
    import {TAG_PAGE} from '~/keys';
    import TagPageBreadcrumbs from './TagPageBreadcrumbs.vue';
    import TagPageDescription from './TagPageDescription.vue';
    import TagPageTitle from './TagPageTitle.vue';

    const refHero = ref<HTMLElement | null>(null);

    const {prismicTemplate} = inject(TAG_PAGE) || {};
    defineProps<{tag: string}>();

    const ctaLabel = prismicTemplate?.data.heroCtaLabel;
    const ctaUrl = prismicTemplate?.data.heroCtaUrl;
    const prismicImage = prismicTemplate?.data.heroImage;

    useComponentTracking(refHero);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .tag-page__hero {
        @include mq.screen_lg(min) {
            margin-bottom: var(--joy-core-spacing-12);
        }

        .slice-content {
            position: relative;
            text-align: left;
        }

        &__wrapper {
            position: relative;

            @include mq.screen_md(min) {
                display: flex;
                gap: var(--joy-core-spacing-12);
                flex: 1 1;
                align-items: center;
            }
        }

        &__image {
            display: none;

            @include mq.screen_md(min) {
                display: block;
                max-width: 45%;

                img {
                    width: 100%;
                }
            }
        }
        &__shape {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            overflow: visible;
            width: 100%;
        }
    }
</style>
